import instance from './API';
import { isArray, join, trim, escape } from 'lodash';

const productPackageAPI = {
  getProductPackage: (id) => {
    return instance.get(`/ProductPackage/${id}`);
  },
  sendProductPackageToUser: (packageId, userId, buyCount) => {
    return instance.post(`/AddPackageToUser/${packageId}`, null, {
      params: {
        customerId: userId,
        count: buyCount,
      },
    });
  },
  getUserProductPackage: (orderNumber, userId) => {
    return instance.get(`/UserProductPackage`, {
      params: {
        orderNumber: orderNumber,
        customerId: userId,
      },
    });
  },
  cancelUserProductPackage: (orderNumber, userId) => {
    return instance.delete('/CancelProductPackage', {
      params: {
        orderNumber: orderNumber,
        customerId: userId,
      },
    });
  },
  getUserProductPackages: (
    page,
    count,
    status,
    startDate = '',
    endDate = '',
    keyword = '',
    userId = '',
  ) => {
    const params = {
      page,
      count,
      status,
    };

    /**
     * startDate 和 endDate 後端需要有參數但如沒有選擇則代入 null
     * keyword 和 userId 有值再代入參數即可
     */
    params.startDate = trim(startDate) !== '' ? startDate : null;
    params.endDate = trim(endDate) !== '' ? endDate : null;

    if (trim(keyword) !== '') {
      params.keyword = keyword;
    }

    if (trim(userId) !== '') {
      params.customerId = userId;
    }

    return instance.get('/UserProductPackageList', {
      params,
    });
  },
  getProductPackages: (page, count, search) => {
    return instance.get('/ProductPackageList', {
      params: {
        page: page,
        count: count,
        status: trim(search.status) !== '' ? search.status : '-1',
      },
    });
  },
  createProductPackage: (productPackage) => {
    const createParams = new URLSearchParams();

    createParams.append('Status', productPackage.status);
    createParams.append('Name', productPackage.name);
    createParams.append('Description', escape(productPackage.description));
    createParams.append(
      'Barcode',
      trim(productPackage.barcode) !== '' ? productPackage.barcode : '',
    );
    createParams.append(
      'Price',
      trim(productPackage.price) !== '' ? productPackage.price : '0',
    );
    createParams.append('StoreId', productPackage.storeId);
    createParams.append('MemberType', productPackage.memberType);

    return instance.post(`/ProductPackage`, createParams);
  },
  updateProductPackage: (id, productPackage) => {
    const updateParams = new URLSearchParams();

    updateParams.append('Status', productPackage.status);
    updateParams.append('Name', productPackage.name);
    updateParams.append('Description', escape(productPackage.description));
    updateParams.append(
      'Barcode',
      trim(productPackage.barcode) !== '' ? productPackage.barcode : '',
    );
    updateParams.append(
      'Price',
      trim(productPackage.price) !== '' ? productPackage.price : '0',
    );
    updateParams.append('StoreId', productPackage.storeId);
    updateParams.append('MemberType', productPackage.memberType);

    return instance.put(`/ProductPackage/${id}`, updateParams);
  },
  uploadProductPackageImg: (id, imgFile, isCover) => {
    const uploadParams = new FormData();

    uploadParams.append('Image', imgFile);
    uploadParams.append('IsCover', isCover);
    uploadParams.append('ProductPackageId', id);

    return instance.post(`/ProductPackage/Image`, uploadParams);
  },
  deleteProductPackageImg: (imgId) => {
    return instance.delete(`/ProductPackage/Image/${imgId}`);
  },
  setProductPackageImgCover: (imgId) => {
    return instance.patch(`/ProductPackage/Image/${imgId}`);
  },
  removePackageProduct: (packageProductId) => {
    const removeIds = isArray(packageProductId)
      ? join(packageProductId, ',')
      : packageProductId;

    return instance.delete(
      `/ProductPackage/Product?productRelationIds=${removeIds}`,
    );
  },
  addProduct: (productPackageId, bonusProductId, isGift, count, expriyDay) => {
    const addParams = new URLSearchParams();

    addParams.append('ProductPackageId', productPackageId);
    addParams.append('BonusProductId', bonusProductId);
    addParams.append('IsGift', isGift === true ? true : false);
    addParams.append('Count', count);

    if (trim(expriyDay) !== '' && isGift === true) {
      addParams.append('PackageExpriyDateDay', expriyDay);
    }

    return instance.post('/ProductPackage/Product', addParams);
  },
  downloadProductPackageUsageExcel: (startAt, endAt) => {
    return instance.get('/Member/PayingMember/Excel', {
      params: {
        startAt: startAt,
        endAt: endAt,
      },
      responseType: 'blob',
    });
  },
};

export default productPackageAPI;
